<div *ngIf="blocked" class="flex h-screen w-full items-center justify-center bg-gray-100">
  <p class="text-sm text-gray-400">This page must be accessed through the nSide platform.</p>
</div>

<div *ngIf="!blocked" class="min-h-screen bg-[#f9f9f9]">
  <ng-container *ngIf="showShell; else bareOutlet">
    <app-sidebar [mode]="sidebarMode" (modeChange)="onSidebarModeChange($event)"></app-sidebar>

    <main
      class="h-screen overflow-auto transition-all"
      [ngClass]="{
        'ml-60 duration-150': sidebarMode === 'large',
        'ml-[108px] duration-300': sidebarMode === 'small'
      }">
      <router-outlet />
    </main>
  </ng-container>

  <ng-template #bareOutlet>
    <router-outlet />
  </ng-template>
</div>
